/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Injectable } from "@angular/core";

@Injectable()
export class CustomPreloadingStrategy implements PreloadingStrategy{
    
    preload(route: Route, loadModule: Function): Observable<any> {
        console.log
        return route.data && route.data.applyPreload ? loadModule() : of(null);
    }
}